import { type DomainRouteName } from 'domains/retailer-collections/routing/routes'
import {
  useGoToPathFactory,
  useScopedPathnameFactory,
  useGetScopedPathnameFactory,
} from 'utils/core/factories/routing/routingHooks.factories'

export const useDomainScopedPathname = useScopedPathnameFactory<DomainRouteName>()
export const useDomainGoToPath = useGoToPathFactory<DomainRouteName>()
export const useDomainGetScopedPathname = useGetScopedPathnameFactory<DomainRouteName>()
